import type { EnvConfig } from '@license-manager/types';
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable @nx/enforce-module-boundaries */
import {
  Module,
  VuexModule,
  Mutation,
  Action,
  MutationAction,
} from 'vuex-module-decorators';
import $http from '../services/api';

@Module({ namespaced: true })
export default class RegisterTan extends VuexModule {
  private readonly urlPrefix = 'envconfig';
  private envConfig: EnvConfig = null;

  @Mutation
  setEnvConfig(config: EnvConfig) {
    this.envConfig = config;
  }

  @Action({ commit: 'setEnvConfig' })
  async loadEnvConfig() {
    const conf = await $http
      .get(this.urlPrefix)
      .then((resp) => resp.data)
      .catch(() => null);

    this.context.commit('setEnvConfig', conf);

    return conf;
  }

  get showEnvBanner() {
    return this.envConfig?.environment?.deployment != 'production';
  }

  get activeEnvConfig(): EnvConfig {
    return this.envConfig;
  }
}
